<template>
 <header class="p-3 d-flex bg-white flex-shrink-0" style="z-index: 1021;">
        <div class="flex-fill">
<a class="logo-wide d-sm-block d-none" href="https://www.isbe.net/" title="Illinois State Board of Education">
<img src="https://apps.isbe.net/cdn/compatibility/secqa1/CDN/v2.0.0/images/d7e4a409feca23469f26ab105820fba1.png" alt="ISBE Logo Wide" />
</a>
<a class="logo-narrow d-block d-sm-none" href="https://www.isbe.net/" title="Illinois State Board of Education">
<img src="https://apps.isbe.net/cdn/compatibility/secqa1/CDN/v2.0.0/images/d0ceb9734df74efe0bab37eed2f19bb1.png" alt="ISBE Logo" />
</a>
</div>
        <div class=" d-none d-lg-flex align-items-center">
            <div class='btn-group dropdown'>
                <a class='dropdown-toggle' href='#' role='button' id='dropdownMenuLink' data-toggle='dropdown'
                    aria-haspopup='true' aria-expanded='false'>
                    Contact Technical Support
                </a>
                <div class='dropdown-menu' aria-labelledby='dropdownMenuLink'>
                    <!-- <a class="dropdown-item" href='https://sec1.isbe.net/iwas/asp/feedback.asp'><i class='fas fa-file mr-2'></i>Submit Web Help</a> -->
                    <a class="dropdown-item" href='tel:217-782-5589'><i class='fas fa-phone mr-2'></i>217-782-5589</a>
                </div>
            </div>
            <a href='https://www.isbe.net/Pages/Privacy-Policy.aspx' target="_blank" title='privacy policy' class='mx-4'>Privacy Policy</a>            
        </div>
    </header>
</template>

<script>
export default {
  name: 'Header'
}
</script>